import { getConfig } from '@/lib/config'

const { publicRuntimeConfig } = getConfig()
const LOGIN_BASE_URL = publicRuntimeConfig?.auth.loginUrl || 'https://www.getsetup.io/auth'
const SIGN_UP_BASE_URL = publicRuntimeConfig?.auth.signUpUrl || 'https://www.getsetup.io/auth'

function toAuthUrl(baseUrl: string, returnToPath?: string): string {
  if (!returnToPath || returnToPath === '' || returnToPath === '/') {
    return baseUrl
  }

  try {
    const returnToUrl = new URL(returnToPath, window.location.origin)

    // Handle both absolute and relative baseUrl
    let authUrl: URL
    if (baseUrl.startsWith('http://') || baseUrl.startsWith('https://')) {
      // Absolute URL
      authUrl = new URL(baseUrl)
    } else {
      // Relative URL - construct with current origin
      authUrl = new URL(baseUrl, window.location.origin)
    }

    if (returnToUrl) authUrl.searchParams.set('returnTo', returnToUrl.toString())
    return authUrl.toString()
  } catch (error) {
    console.error('Error constructing auth URL:', error)
    // Fallback to simple concatenation if URL construction fails
    return baseUrl
  }
}

export function toLoginAuthUrl(returnToPath?: string): string {
  return toAuthUrl(LOGIN_BASE_URL, returnToPath)
}

export function toSignUpAuthUrl(returnToPath?: string): string {
  return toAuthUrl(SIGN_UP_BASE_URL, returnToPath)
}
